module.exports = __webpack_public_path__ + "img/l-banner-verify-bg.18c23c11.png";